import { call } from '../../shared/api.ts'
import type { apiDto, apiStats } from '@rs/contracts'

/**
 * ══ CỬA GỌI REST — THỐNG KÊ · HIỆU QUẢ NHÀ THẦU · DASHBOARD (F26) ════════════════════════════
 *
 * ⭐ MỘT LỜI GỌI, BỐN BẢNG. Bốn bảng trên cùng một màn phải nói về CÙNG MỘT ảnh chụp — bốn lời gọi
 *   rời nhau có thể rơi vào giữa một giao dịch đang ghi và ra bốn con số không cộng lại được.
 */
export type StatsReport = apiDto.StatsReportDto
export type StatsSale = apiDto.StatsSaleDto
export type StatsVendor = apiDto.StatsVendorDto
export type StatsRoute = apiDto.StatsRouteDto
export type StatsPack = apiDto.StatsPackDto
export type StatsCustomer = apiDto.StatsCustomerDto
export type StatsOrder = apiDto.StatsOrderDto
export type StatsUnbilled = apiDto.StatsUnbilledDto
export type StatsMonth = apiDto.StatsMonthDto

export const fetchStats = (from: string, to: string, basis: 'plan' | 'actual' | 'invoice' = 'plan'): Promise<StatsReport> =>
  call<StatsReport>(`/api/v1/az/thong-ke?from=${from}&to=${to}${basis === 'plan' ? '' : `&basis=${basis}`}`)

export type DashOverview = apiDto.DashOverviewDto

/** 📊 Dashboard ▸ Tổng quan — sản lượng · báo cáo vỏ lạnh (`0122`). Hai kỳ đối chiếu là của MÀN. */
export const fetchDashOverview = (q: { from: string; to: string; basis: string; prevFrom: string; prevTo: string; yoyFrom: string; yoyTo: string; year: string }): Promise<DashOverview> =>
  call<DashOverview>(`/api/v1/az/thong-ke/tong-quan?${new URLSearchParams(q).toString()}`)

export type DashYearChart = apiDto.DashYearChartDto

/** 📊 Dashboard ▸ Tổng quan — biểu đồ trọn năm, công thức BẢN CŨ (`0148`): doanh thu = hoá đơn bán, chi phí = bốn ô chi phí đơn. */
export const fetchDashYearChart = (year: number): Promise<DashYearChart> =>
  call<DashYearChart>(`/api/v1/az/thong-ke/bieu-do-nam?year=${String(year)}`)

/** 📈 Hiệu quả thầu phụ (`VendorPnlTab`) — ba bảng + dữ liệu bấm số ra chi tiết, máy chủ lọc và cộng. */
export type VendorPnl = apiDto.VendorPnlDto
export const fetchVendorPnl = (body: apiStats.VendorPnlBodyT): Promise<VendorPnl> =>
  call<VendorPnl>('/api/v1/az/hieu-qua-thau-phu', { method: 'POST', body: JSON.stringify(body) })

/** 📌 Dải "Đơn đang mở" của `/az/vendor-pnl` — cửa riêng, quyền đọc đơn (không đòi xem giá vốn), bản cũ `Az.tsx:613`. */
export type OpenOrders = apiDto.OpenOrdersDto
export const fetchOpenOrders = (): Promise<OpenOrders> => call<OpenOrders>('/api/v1/az/don-dang-mo')
